module.exports = __webpack_public_path__ + "static/media/header_two_ham.01f441d5.jpg";